import { Box, BoxProps } from "@mui/material";

export default function Page(
  props: { small?: boolean; centered?: boolean; extraWide?: boolean; fullWidth?: boolean } & BoxProps,
) {
  const { children, sx, small = false, extraWide = false, fullWidth = false, centered = true, ...boxProps } = props;
  let maxWidth = "1680px";

  if (fullWidth) {
    maxWidth = "100%";
  } else if (small) {
    maxWidth = "1280px";
  } else if (extraWide) {
    maxWidth = "1800px";
  }

  const defaultSx = { width: "100%", maxWidth, margin: centered ? "0 auto" : 0 };

  return (
    <Box component="div" sx={{ ...defaultSx, ...sx }} {...boxProps}>
      {children}
    </Box>
  );
}
